import React from 'react';
import PropTypes from 'prop-types';
import styles from 'styles/Error.module.scss';
import { toast } from 'react-toastify';
import Router from 'next/router';
import { showToastError } from '@core/components/toastify/ToastTypes';

export default function ErrorPage({ error }) {
  showToastError('No information found(403)');
  Router.push('/');
  const status = error?.status || 404;
  let message = 'Page not found!';
  if (error?.data?.errors?.[0]?.msg) {
    message = error.data.errors[0].msg;
  }
  if (error?.data && typeof error?.data === 'string') {
    message = error?.data;
  }

  let description =
    'We are sorry but the page you are looking for does not exist';
  if (error?.status === 401) {
    description =
      'We are sorry but you do not have permission to view this page';
  }

  return (
    <></>
    // <div className={styles.notfoundPage}>
    //   <div className={styles.notfoundContent}>
    //     <h3>Oops! {message}</h3>
    //     <h1>{status}</h1>
    //   </div>
    //   <h2>{description}</h2>
    // </div>
  );
}

ErrorPage.propTypes = {
  error: PropTypes.object.isRequired,
};
